/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDomainRegion = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M23.8 9H13V1.05c.329-.033.662-.05 1-.05 4.838 0 8.873 3.436 9.8 8zm-4.452-2h1.582a8.04 8.04 0 0 0-2.719-2.803c.444.825.836 1.773 1.137 2.803zM15 3.206V7h2.251a12.132 12.132 0 0 0-.88-2c-.47-.84-.956-1.435-1.371-1.794z" />
        <path d="M10.526 2.108c.157-.023.315-.043.474-.059v2.136c-.42.356-.917.958-1.395 1.815a12.02 12.02 0 0 0-.881 2H11v2H8.21a12.642 12.642 0 0 0-.09 4H11v-3h2v3h2.857c.143-1.013.149-2.024.05-3h2.008c.086.972.08 1.98-.042 3h1.875a8.016 8.016 0 0 0 .19-3h2.013c.032.329.049.662.049 1 0 5.523-4.477 10-10 10S2 17.523 2 12c0-5.02 3.7-9.178 8.523-9.892zM4.252 10a8.047 8.047 0 0 0 0 4h1.85a14.724 14.724 0 0 1 .08-4zm.818-2h1.557c.298-1.02.686-1.96 1.125-2.78A8.04 8.04 0 0 0 5.07 8zM11 16H8.593a10.678 10.678 0 0 0 2.388 3.936l.019.002zm-3.403 2.68A12.535 12.535 0 0 1 6.499 16H5.07a8.04 8.04 0 0 0 2.527 2.68zm8.767.026A8.04 8.04 0 0 0 18.93 16h-1.454a12.54 12.54 0 0 1-1.111 2.706zM15.383 16H13v3.93A10.676 10.676 0 0 0 15.383 16z" />
      </g>
    </g>
  </Icon>
);
export { SvgDomainRegion as DomainRegion };
